import React, { useContext, useMemo, useState } from "react";
import { IconButton, makeStyles } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
  wrapper: {
    // width: 1080,
    // height: 35 + theme.spacing(3),
    // overflow: "hidden"
  }
}));

const CollapseContext = React.createContext({});

function CollapsePanel({ children }) {
  const classes = useStyles();

  const [isCollapsed, setCollapsed] = useState(true);

  const contextValue = useMemo(() => {
    return {
      isCollapsed,
      setCollapsed
    };
  }, [isCollapsed]);

  return (
    <CollapseContext.Provider value={contextValue}>
      <div className={classes.wrapper}>{children}</div>
    </CollapseContext.Provider>
  );
}

export function CollapseItem({ children }) {
  const { isCollapsed } = useContext(CollapseContext);

  if (isCollapsed) return null;
  return <>{children}</>;
}

export function CollapseTrigger() {
  const { isCollapsed, setCollapsed } = useContext(CollapseContext);

  return (
    <IconButton
      onClick={() => {
        setCollapsed(prev => !prev);
      }}
      style={{
        padding: 7,
        transform: !isCollapsed ? "rotate(180deg)" : ""
      }}
    >
      <ExpandMore />
    </IconButton>
  );
}

export default CollapsePanel;
